<template>
  <div class="selector-holder">
    <div class="selector-label" >{{ selector.label }}</div>
    <SelectorOption v-for="(option, index) in selector.options"
      :id="'s-' + selector.value + '-' + option"
      :key="index"
      :type="selector.value"
      :option="option"
      :ref="option"
      @click="updateSelector($event, option)"
    />
  </div>
</template>

<script>
import SelectorOption from '@/components/pipe/SelectorOption';
import { usePipeStore } from '@/store/PipeStore';

export default {
  name: 'Selector',
  props: [
    'selector'
  ],
  components: {
    SelectorOption
  },
  watch: {
    'usePipeStore().getEditedPipe': {
      handler () {
        this.updateSelector();
      },
      deep: true
    },
  },
  methods: {
    handleSelectorClick () {
    },
    updateSelector (e, option) {
      usePipeStore().getEditedPipe[this.$props.selector.value] = option;
    }
  }
};
</script>

<style scoped>
.selector-holder {
  display: flex;
  margin-bottom: 10px;
}
.selector-label {
  min-width: 60px;
  font-size: 80%;
  font-weight: bold;
}
</style>